import React = require('react')
import { CookieSensitiveContentWrapper } from '../cms/blocks/cookiebar.mod'

export const ParadoxLoader = () => <CookieSensitiveContentWrapper children={<ParadoxLoaderAux />} groupId={2} />

const ParadoxLoaderAux = () => {
  React.useEffect(loadParadox, [])
  return <></>
}

const loadParadox = () => {
  window.oliviaChatData = window.oliviaChatData || []
  window.oliviaChatBaseUrl = 'https://olivia.paradox.ai'
  window.oliviaChatData.push(['setKey', 'divsgweofyhgtseqknds'])
  window.oliviaChatData.push(['start'])
  var apply = document.createElement('script')
  apply.type = 'text/javascript'
  apply.async = true
  apply.src = 'https://dokumfe7mps0i.cloudfront.net/static/site/js/widget-client.js'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(apply, s)
}
